import React, { useState,useEffect } from 'react';
import { useSelector } from 'react-redux';
import MatchingRoomListItem from 'components/presenters/matching/list/MatchingRoomListItem';
import server from 'server/serverController2';
import BottomModal from 'components/presenters/modal/BottomModal';
import CenterModal from 'components/presenters/modal/CenterModal';
import {removeItem} from 'utils/utils';
export default function MatchingRoomList({roomList, setRoomList}) {
  const userInfo = useSelector((state) => {
    return state.userInfo;
  });
  

  //Bottom ModalState
  const [initBottomModal, setInitBottomModal] = useState(false);
  const [bottomModalVisible, setBottomModalVisible] = useState(false);
  const [bottomModalDataList, setBottomModalDataList] = useState([]);

  //Center Modal State
  const [initCenterModal, setInitCenterModal] = useState(false);
  const [centerModalVisible, setCenterModalVisible] = useState(false);
  const [centerModalDataList, setCenterModalDataList] = useState({});
  const [onModalComplete, setOnModalComplete] = useState(null);
  const [onModalCancel, setOnModalCancel] = useState(null);


  //Init Modal State
  useEffect(()=>{
    if(initBottomModal === true)
    {
      setBottomModalVisible(false);
      setBottomModalDataList([]);
      setInitBottomModal(false);
    }
    if(initCenterModal === true)
    {
      setCenterModalVisible(false);
      setCenterModalDataList({})
      setOnModalComplete(null);
      setOnModalCancel(null);
      setInitCenterModal(false);
    }
  }, [initCenterModal, initBottomModal])




  const loadRoomInfo = (roomNo) => {
    for(let i = 0; i < roomList.length; ++i)
    {
      if(roomList[i]['no'] === roomNo)
      {
        return roomList[i];
      }
    }
    return null;
  }
  const getRemovedRoomList = (roomNo) => {
    let newRoomList = roomList;
    let targetIndex = null;
    for(let i = 0; i < newRoomList.length; ++i)
    {
      if(parseInt(newRoomList[i]['no']) === parseInt(roomNo))
      {
        targetIndex = i;
        break;
      }
    }

    if(targetIndex !== null)
    {
      newRoomList = removeItem(newRoomList, targetIndex);
    }
    return (newRoomList);
  }
  const handleDeleteRoom = (roomNo) => {
    server.deleteRequestData(`matching/rooms/${roomNo}`,{},(res)=>{
      if(res.success !== 1)
      {
        return;
      }
      const newRoomList = getRemovedRoomList(roomNo);
      setRoomList(newRoomList);
    })
  }
  const handleOptionClick = (roomNo)=>{
    const roomInfo = loadRoomInfo(roomNo);
    if([null, undefined].includes(roomInfo))
    {
      setCenterModalVisible(true);
      setCenterModalDataList({description:"대화방 정보를 불러오는데 실패하였습니다."});
      setOnModalComplete(()=>()=>{
        setInitCenterModal(true);
      })
      return;
    }

    setBottomModalVisible(true)
    setBottomModalDataList([
              {
                type : "link",
                path : `/matching/room/${roomNo}/update`,
                text: "수정"
              },
              {
                type : "callback",
                callback : ()=>{
                  setInitBottomModal(true);
                  setCenterModalVisible(true);
                  setCenterModalDataList({description:"게시물을 삭제하시겠어요?"});
                  setOnModalComplete(()=>()=>{
                    setInitCenterModal(true);
                    handleDeleteRoom(roomNo);
                  })
                  setOnModalCancel(()=>()=>{
                    setInitCenterModal(true);
                  })
                },
                style: {color: '#DE0000'},
                text: "삭제"
              }]
    )
  }
  return (
    <div>
    {
      roomList.map((value, index)=>{
        const isOwner = (parseInt(value['user_no']) === parseInt(userInfo['id']))? true: false;
        return (
          <div key={`matching-room-item-${value['no']}`} style={{marginBottom : 'calc(100vw * (20 / 375))'}}>
            <MatchingRoomListItem isOwner={isOwner} roomInfo={value} onOptionClick={handleOptionClick}/>
          </div>
        )
      })
    }

      <CenterModal modalVisible={centerModalVisible} setModalVisible={setCenterModalVisible} dataList={centerModalDataList} onCancel={onModalCancel} onComplete={onModalComplete}/>
      <BottomModal visible={bottomModalVisible} setVisible={setBottomModalVisible} dataList={bottomModalDataList} />
    </div>
  );
}